export const apiCreate = (): string => '/commercial/creditLines/create'
export const apiList = (id?: string): string =>
  !id ? '/commercial/creditLines/' : `/commercial/creditLines/view/${id}`
export const apiUpdate = (id: string): string =>
  `/commercial/creditLines/update/${id}`
export const apiDelete = (id: string): string =>
  `/commercial/creditLines/delete/${id}`
